import styled from 'styled-components';

const CoverageWraper = styled.div`
margin:auto;
padding:60px 0;
background-color: #f3f5f8;
}
.coverage h3 {
	font-size: 24px;
	font-weight: 800;
	line-height: 1.33;
	text-align: initial;
	color: #4c565c;
}
.control-label:after {
	content: "*";
	color: red;
}

`;

export default CoverageWraper;